import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MainMenuComponent } from '../../shared/main-menu/main-menu.component';
import { InfraMenuComponent } from '../../shared/infra-menu/infra-menu.component';
import { ScriptLoaderService, VENDOR_SCRIPTS } from '../../script-loader.service';
import { SubscribeComponent } from '../../shared/subscribe/subscribe.component';

@Component({
  selector: 'app-events',
  standalone: true,
  imports: [CommonModule, MainMenuComponent, InfraMenuComponent, SubscribeComponent],
  templateUrl: '../templates/events.component.html'
})
export class EventsComponent implements AfterViewInit, OnDestroy {
  constructor(private readonly scriptLoader: ScriptLoaderService) { }

  ngAfterViewInit(): void {
    document.body.classList.add('defult-home');
    this.scriptLoader
      .loadSequential(...VENDOR_SCRIPTS)
      .then(() => {
        // If vendor scripts were injected after the native load event,
        // re-dispatch it so jQuery load handlers in main.js still run.
        if (document.readyState === 'complete') {
          window.dispatchEvent(new Event('load'));
        }

        this.initializeGalleryPopup();
      })
      .catch((error) => {
        console.error('Failed to load third-party scripts', error);
      });
  }

  ngOnDestroy(): void {
    document.body.classList.remove('defult-home');
  }

  private initializeGalleryPopup(): void {
    const win = window as unknown as { $?: any; jQuery?: any };
    const $ = win.jQuery ?? win.$;

    if (!$ || !$.fn?.magnificPopup) {
      return;
    }

    const galleryContainers = $('.rs-gallery');
    if (!galleryContainers.length) {
      return;
    }

    // Bind popup per gallery container so Next/Prev stays within that block only.
    galleryContainers.each(function eachContainer(this: any): void {
      const container = $(this);
      container.off('click.magnificPopup');

      container.magnificPopup({
        delegate: 'a.image-popup',
        type: 'image',
        callbacks: {
          beforeOpen: function beforeOpen(this: any): void {
            this.st.image.markup = this.st.image.markup.replace(
              'mfp-figure',
              'mfp-figure animated zoomInDown'
            );
          }
        },
        gallery: {
          enabled: true
        }
      });
    });
  }
}


